import { render, staticRenderFns } from "./Wscene.vue?vue&type=template&id=ea892e2a&"
import script from "./Wscene.vue?vue&type=script&lang=js&"
export * from "./Wscene.vue?vue&type=script&lang=js&"
import style0 from "./Wscene.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports